import React from "react";
import CommentContext from "./contexts";

export const useComments = () => React.useContext(CommentContext);
